export default __webpack_public_path__ + "static/media/Info.c4babfed.svg";